import { ref } from "vue"

const listener = ref<(() => void) | undefined>()

export function useCookieBanner() {
	return {
		setup: (cb: () => void): void => {
			listener.value = cb
		},
		open: (): void => {
			listener.value?.()
		}
	}
}
